import { TextField } from "@mui/material";
import { GridFilterOperator } from "@mui/x-data-grid-pro";
import createFilter from "./helpers/CreateFilterHelper";

const CustomFilterOperatorInputText = (props: any) => {
    const { item, applyValue } = props;
    const handleChange = (event: any) => {
      applyValue({ ...item, value: event.target.value });
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (!event.ctrlKey && event.key !== "Enter") {
        event.stopPropagation();
      }
    };

    return <TextField 
    placeholder={props.label}  
    onKeyDown={handleKeyDown} 
    variant="filled" 
    size="small" value={item.value || ''} 
    onChange={handleChange} 
    inputProps={{ "aria-label":"Text Filter Input" }}
    />;
  };
  
  const TextFilterOperator: GridFilterOperator[] = [
      {
        label: 'Contains',
        value: 'contains',
        getApplyFilterFn: createFilter((cellValue, filterValue) => {
          return cellValue.toString().toLowerCase().includes(filterValue.toString().toLowerCase())
        }
        ),
        InputComponentProps: { type: 'text' },
        InputComponent: CustomFilterOperatorInputText,
      },
      {
          label: 'Equals',
          headerLabel: 'Equals',
          value: 'eq',
          getApplyFilterFn: createFilter((cellValue, filterValue) => 
            cellValue.toString().toLowerCase() === filterValue.toString().toLowerCase()
          ),
          InputComponentProps: { type: 'text' },
          InputComponent: CustomFilterOperatorInputText,
      },      
      {
          label: 'Not Equals',
          value: 'neq',
          getApplyFilterFn: createFilter((cellValue, filterValue) => 
            cellValue.toString().toLowerCase() !== filterValue.toString().toLowerCase()
          ),
          InputComponentProps: { type: 'text' },
          InputComponent: CustomFilterOperatorInputText,
      },
  ];

export default TextFilterOperator;